import axios from 'axios'
import Error from '../kne/error'
import { IPatch, IReleasePatchRequest, IPatchIdRequest } from '../model/ProductsState'

export default class PatchService {
    releasePatch(patchReleaseRequest: IReleasePatchRequest): Promise<IPatch> {
        return new Promise((resolve, reject) => {
            axios.post("/api/patch/releasePatch", patchReleaseRequest).then((response) => {
                resolve(response.data as IPatch)
            }, (err: Error) => {
                reject(err)
            })
        })
    }

    deletePatch(patchId: IPatchIdRequest): Promise<boolean> {
        return new Promise((resolve, reject) => {
            axios.post("/api/patch/deletePatch", patchId).then((response) => {
                resolve(response.data)
            }, (err: Error) => {
                reject(err)
            })
        })
    }
}